module.exports = __webpack_public_path__ + "static/media/001-descendant.82de462e.svg";